import api from '@a/config';

const path = 'v1/infra/teilegruppe';

export default {
  get: () => api.get(path),
};
